import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectActiveTemplateId = createSelector(
  getSystem,
  ({ emailTemplatesControlUI }) => emailTemplatesControlUI.activeTemplateId,
);

export const selectActiveTemplateCategoryId = createSelector(
  getSystem,
  ({ emailTemplatesControlUI }) => emailTemplatesControlUI.activeTemplateCategoryId,
);
